import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "@redux/slices/authSlice";

const Deactivated = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full p-8 rounded-2xl border border-red-200 bg-white shadow-2xl text-center">
        <div className="w-20 h-20 mx-auto bg-red-500/20 rounded-full flex items-center justify-center mb-6">
          <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Account Suspended</h2>
        <p className="text-gray-600 mb-8 leading-relaxed">
          Your company's subscription has been deactivated. Please contact your administrator or Z-Ninth support to restore access to your integrations and data.
        </p>
        <button
          onClick={handleLogout}
          className="w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition duration-200 font-medium active:scale-95 shadow-md"
        >
          Return to Login
        </button>
      </div>
    </div>
  );
};

export default Deactivated;